// extracted by mini-css-extract-plugin
module.exports = {"swiper":"HorLayout_swiper_2zwi-","swiper_item":"HorLayout_swiper_item_K00E9"};